import { ComponentProps } from "react";

const NoEffectArrow = ({
	shade = "#6f468e",
	...props
}: ComponentProps<"svg"> & { shade?: string }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.95 4.34" {...props}>
		<g data-name="Layer 2">
			<path fill="#624081" data-name="Layer 1" d="M0 0H11.95V4.34H0z" />
		</g>
	</svg>
);

export default NoEffectArrow;
